"use client"

const GoogleMap = () => {
  return (
    <>
   
     <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.0152212943367!2d77.22376489999999!3d28.6293059!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd0d4e167367%3A0x2ac7e3d79f22a731!2sFast%20Track%20Visa!5e0!3m2!1sen!2sin!4v1758015816007!5m2!1sen!2sin" 
        width="600" 
        height="300" 
        style={{ border: "1px solid #ddd", padding: "10px", borderRadius: "5px", marginTop: "20px", width: "100%" }} 
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade">
        </iframe>
     </>
  )
}

export default GoogleMap